module.exports = __webpack_public_path__ + "img/ring_g_0_null_1@2x.d4615dde.png";